const Basic = {
  background: '#f5f5f7',
  color: '#111',
};

export default Basic;
